enum RouterPaths {
  MAP = '/map',
  AIRCRAFT = '/aircraft',
  AIRCRAFT_NEW = '/aircraft/new',
  AIRCRAFT_EDIT = '/aircraft/:id',
  AIRCRAFT_REGISTER = 'register',
  WB_PROFILES_NEW = 'wb-profiles/new',
  WB_PROFILES_EDIT = 'wb-profiles/:id',
  WB_CREATION_MODE = 'creation-mode',
  USE_ANOTHER_TEMPLATE = 'use-another-template',
  WB_CHOOSE_TEMPLATE = 'choose-template',
  WB_UNITS = 'wb-units',
  WB_STEPS = 'wb-steps',
  WB_MAC = 'wb-mac',
  WB_BASIC_EMPTY_WEIGHT = 'basic-empty-weight',
  WB_SEATS = 'seats',
  WB_CARGO = 'cargo',
  WB_TANK = 'tank',
  WB_MAXIMUM_WEIGHTS = 'maximum-weights',
  WB_ENVELOPE = 'envelope',
  ROUTES_PANEL = '/routes-panel',
  WEIGHT_AND_BALANCE = '/weight-and-balance',
  DEFAULT_WEIGHTS_MANAGEMENT = 'manage-default-weights',
  WEIGHT_AND_BALANCE_NEW = 'new',
  WEIGHT_AND_BALANCE_CREATION_MODE = 'creation-mode',
  WEIGHT_AND_BALANCE_EDIT = ':id',
  WB_FLIGHT_SETUP = 'flight-setup',
  WB_FLIGHT_FILLING = 'flight-filling',
  VERTICAL_NAVIGATION = '/vertical-navigation',
  SAVED_ROUTES = '/saved-routes',
  PROCEDURE_CHARTS = '/procedure-charts',
  ADHP_INFO = '/adhp-info',
  MARKET = '/market',
  BETA = '/beta-info',
  MOBILE = '/mobile',
  NEWS = '/news',
  SETTINGS = '/settings',
  SETTINGS__DATA_AND_CHARTS = 'data-and-charts',
  SETTINGS__ROUTE_WAYPOINT_INSERTION_MODE = 'route-waypoint-insertion-mode',
  MY_CONTENT = '/my-content',
  MY_CONTENT__USER_WAYPOINTS = 'user-waypoints',
  MY_CONTENT__USER_WAYPOINTS__CREATE = 'create',
  MY_CONTENT__USER_WAYPOINTS__EDIT = 'edit/:name/:id',
  MY_CONTENT__USER_CHARTS = 'user-charts',
  MY_CONTENT__USER_CHARTS__UPLOAD = 'upload',
  MY_CONTENT__USER_CHARTS__EDIT = 'edit/:id',
  MY_CONTENT__USER_GEOMETRIES = 'user-geometries',
  MY_CONTENT__USER_GEOMETRIES__UPLOAD = 'upload',
  MY_CONTENT__USER_GEOMETRIES__EDIT = 'edit/:id'
}

export { RouterPaths }
